module.exports = __webpack_public_path__ + "static/media/partneri.cb6ba019.svg";